export enum DeleteSetCardActionTypes {
  DELETING = 'set-cards/DELETING',
  DELETED = 'set-cards/DELETED',
}
